import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getSettings, setSettings } from '~/services/SupportService';

import { settingsHistoryQueryKeys } from './useSettingsHistory';

export const supportSettingsQueryKeys = {
  all: ['support-settings'] as const,
  detail: () => [...supportSettingsQueryKeys.all, 'detail'] as const,
};

interface UseGetSettingsParams {
  enabled?: boolean;
}

export function useGetSettings({ enabled = true }: UseGetSettingsParams = {}) {
  return useQuery({
    queryKey: supportSettingsQueryKeys.detail(),
    queryFn: async () => {
      const { result } = await getSettings();
      return result;
    },
    enabled,
  });
}

export function useUpdateSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Parameters<typeof setSettings>[0]) => setSettings(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: supportSettingsQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: settingsHistoryQueryKeys.all });
    },
  });
}
